/* eslint-disable no-undef */

import { TRACK_USER } from "../actions/trackUser";


const initialState = {
  session_id: '_' + Math.random().toString(36),
  version: process.env.REACT_APP_VERSION,
  event: '',
  page: '',
  search: '',
  from: '',
  date: '',
  agent: '',
  device: '', 
  detail: {}
};

const userTrackReducer = (state = initialState, action) => {
  switch (action.type) {
  case TRACK_USER:
    return {
      ...state,
      ...action.payload
    };
    
  default:
    return state;
  }
};

export default userTrackReducer;
